import router from "@/router/index";

export default function addConditionalRoutes(router, store) {
  // about_us: true,
  // delivery_and_payment: true,
  // blog: true,
  const presence = store.state.settings.pages_presence;

  if (presence.about_us) {
    router.addRoutes([
      {
        path: '/about-us',
        name: 'about-us',
        component: () => import('@/pages/AboutUsPage'),
      }
    ]);
  }

  if (presence.delivery_and_payment) {
    router.addRoutes([
      {
        path: '/delivery-and-payment',
        name: 'delivery-and-payment',
        component: () => import('@/pages/DeliveryAndPaymentPage'),
      }
    ]);
  }

  if (presence.blog) {
    router.addRoutes([
      {
        path: '/blog',
        name: 'blog-list',
        component: () => import('@/pages/Blog/BlogArticlesListPage'),
      },
      {
        path: '/blog/category/:categoryShortId/:categorySlug',
        name: 'blog-list-category',
        component: () => import('@/pages/Blog/BlogArticlesListPage'),
        props: true,
      },
    ])
  }

  // Always add single article route (there might be hidden articles that must be accessible by full URL).
  router.addRoutes([
    {
      path: '/blog/:shortId/:slug',
      name: 'blog-item',
      component: () => import('@/pages/Blog/BlogArticleItemPage'),
      props: true,
    },
  ])

  if (presence.offers) {
    router.addRoutes([
      {
        path: '/offers',
        name: 'offers-list',
        component: () => import('@/pages/Offers/OffersListPage'),
      },
      {
        path: '/offers/:shortId/:slug',
        name: 'offer-page',
        component: () => import('@/pages/Offers/OfferArticlePage'),
        props: true,
      },
    ])
  }

  router.addRoutes([
    {
      path: '*',
      name: 'errors.404',
      component: () => import('@/pages/Errors/Error404'),
    }
  ])
}
